import { render, staticRenderFns } from "./ShiftsView.vue?vue&type=template&id=ec5b4b06&"
import script from "./ShiftsView.vue?vue&type=script&lang=js&"
export * from "./ShiftsView.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsView.vue?vue&type=style&index=0&id=ec5b4b06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports